import { QuoteSummaryTreatment } from "./QuoteSummaryTreatment";

const QuoteSummary = ({
  showPricing = false,
  showBookingCTA = false,
  showFileUploads = false,
}: {
  showPricing?: boolean;
  showBookingCTA?: boolean;
  showFileUploads?: boolean;
}) => {
  return (
    <QuoteSummaryTreatment
      showPricing={showPricing}
      showBookingCTA={showBookingCTA}
      showFileUploads={showFileUploads}
    />
  );
};

export default QuoteSummary;
